import * as types from '@/store/mutation-types';

const state = {
    "requestedScene": null,
    "showPlotCount": false,
    'displayFavorite': false
};

const getters = {
    requestedScene: (state) => state.requestedScene,
    showPlotCount: (state) => state.showPlotCount,
    displayFavorite: (state) => state.displayFavorite
};

const actions = {
    setWidgetScene({ commit }, scene) {
        commit(types.SET_WIDGET_SCENE, scene);
    },
    setPlotCount({ commit }, status) {
        commit(types.SET_PLOT_COUNT, status);
    },
    setDisplayFavorite({ commit }, status) {
        commit(types.SET_DISPLAY_FAVORITE, status);
    }
};

const mutations = {
    [types.SET_WIDGET_SCENE](state, scene) {
        state.requestedScene = scene;
    },
    [types.SET_PLOT_COUNT](state, status) {
        state.showPlotCount = status;
    },
    [types.SET_DISPLAY_FAVORITE](state, status) {
        state.displayFavorite = status;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/widget.js